import { Avatar as AvatarMui, Box, Typography } from '@mui/material';
import { ConditionalLoader } from 'dashboard409a/pages/Operations/components';
import { getInitials } from 'utilities/getInitials';
import { AvatarContainer } from './Avatar.styles';

interface AvatarProps {
  src: string;
  name: string;
  roleTitle: string;
  isLoading?: boolean;
}

const Avatar = ({ src, name, roleTitle, isLoading }: AvatarProps) => (
  <AvatarContainer>
    <AvatarMui alt={name} src={src} sx={{ width: 40, height: 40 }}>
      {getInitials({ name })}
    </AvatarMui>
    <Box>
      <ConditionalLoader isLoading={isLoading} width={150} height={20}>
        <Typography fontWeight="bold">{name}</Typography>
      </ConditionalLoader>
      <ConditionalLoader isLoading={isLoading} width={100} height={20}>
        <Typography variant="body2" color="text.secondary">
          {roleTitle}
        </Typography>
      </ConditionalLoader>
    </Box>
  </AvatarContainer>
);

export default Avatar;
